export default {"src":"/_next/static/media/ic-help.71be31e6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};